import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Pagination} from 'kpc';

var _$tmp0 = {
    'total': 200,
    'counts': '10'
};
var _$tmp1 = {
    'total': 200,
    'counts': '9'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Pagination, _$tmp0),
        _$cc(Pagination, _$tmp1)
    ], 4);
};